import { memo } from 'react';
import { Icon } from '@cbhq/cds-web/icons/Icon';

export const FallbackIcon = memo(() => <Icon name="info" size="m" color="fgMuted" active />);
